import { getEnvironmentName, isProductionEnvironment } from '@/shared/utils/environment';
import React from 'react';

export const EnvironmentBadge: React.FC = () => {
  const isProd = isProductionEnvironment();
  const envName = getEnvironmentName();

  return (
    <div
      className={`environment-badge ${isProd ? 'environment-badge--production' : 'environment-badge--test'}`}
    >
      {envName}
    </div>
  );
};
